const changeUrl = (oldUrl, newUrl, replace, history) => {
    if (oldUrl && newUrl && newUrl !== oldUrl) {
        replace ? history.replace(newUrl) : history.push(newUrl)
    }
}

export default changeUrl
